module.exports = __webpack_public_path__ + "img/Professor_Mobile@2x.0209894.webp";